import { Outlet } from 'react-router-dom'

import { Admin, Auth } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'

const admin = [
    {
        path: 'admin',
        element: <Auth guard="admin" />,
        children: [
            { path: 'verify-email', element: <Lazy view={'Auth/VerifyEmail'} /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view={'Auth/VerifyEmail'} /> },
        ],
    },
    {
        path: 'admin',
        element: <Admin guard="admin" />,
        children: [
            { path: '', element: <Lazy view={'Admin/Dashboard'} /> },
            { path: 'profile', element: <Lazy view={'Admin/Dashboard/Profile'} /> },
            { path: 'password', element: <Password /> },
            { path: 'send-mail', element: <Lazy view={'Admin/Dashboard/SendMail'} title="Send Email" /> },
            {
                path: 'admins',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Admins/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Admins/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Admins/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'collection-points',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/CollectionPoints/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/CollectionPoints/Create'} title="Add new Collection Point" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/CollectionPoints/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'collection-point-bag-requests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/CollectionPointBagRequests/List'} /> },
                    {
                        path: 'create',
                        element: (
                            <Lazy
                                view={'Admin/CollectionPointBagRequests/Create'}
                                title="Request Bags or Bins for a Collection Point"
                            />
                        ),
                    },
                    { path: ':id/edit', element: <Lazy view={'Admin/CollectionPointBagRequests/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'affiliates',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Affiliates/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Affiliates/Create'} title="Add new Recycler" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Affiliates/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'storages',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Storages/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Storages/Create'} title="Add new Recycler" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Storages/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Users/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Users/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Users/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'projects',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Projects/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Projects/Create'} title="Add new Project" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Projects/Create'} title="Edit" /> },
                ],
            },
            { path: 'bin-box', element: <Lazy view={'Admin/BinBox/List'} /> },
            { path: 'bin-bags', element: <Lazy view={'Admin/BinBags/List'} /> },
            {
                path: 'project-bag-drops',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/ProjectBagDrops/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/ProjectBagDrops/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/ProjectBagDrops/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'pickups',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Pickups/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Pickups/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Pickups/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'dispatches',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Dispatches/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Dispatches/Create'} title="Add new" /> },
                    { path: ':id', element: <Lazy view={'Admin/Dispatches/Show'} title="View" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Dispatches/Update'} title="Edit" /> },
                ],
            },
            {
                path: 'affiliate-rejected-materials',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/AffiliateRejectedMaterials/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/AffiliateRejectedMaterials/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/AffiliateRejectedMaterials/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'materials',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Materials/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Materials/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Materials/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'batch-reject-types',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/BatchRejectTypes/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/BatchRejectTypes/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/BatchRejectTypes/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'settings',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Settings/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Settings/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Settings/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'file-uploads',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/FileUploads/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/FileUploads/Create'} title="Resources" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/FileUploads/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'contacts',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Contacts/List'} /> },
                    { path: ':id', element: <Lazy view={'Admin/Contacts/Show'} title="View" /> },
                ],
            },
            {
                path: 'member-products',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/MemberProducts/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/MemberProducts/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/MemberProducts/Create'} title="Edit" /> },
                ],
            },
            {
                path: 'report',
                element: <Outlet />,
                children: [
                    {
                        path: 'collection-point-bag-distribution',
                        element: (
                            <Lazy
                                view={'Admin/Report/CollectionPointBagDistribution'}
                                title="Collection Point Bag Distribution Report"
                            />
                        ),
                    },
                    { path: 'project', element: <Lazy view={'Admin/Report/Project'} title="Project" /> },
                ],
            },
            {
                path: 'announcements',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view={'Admin/Announcements/List'} /> },
                    { path: 'create', element: <Lazy view={'Admin/Announcements/Create'} title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view={'Admin/Announcements/Create'} title="Edit" /> },
                ],
            },
        ],
    },
]

export default admin
